// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Statistics-module__coefBox--Yvy0G {
    display: flex;
    justify-content: center;
}

.Statistics-module__coefBox--Yvy0G>h3 {
    color: #6F879C;
    font-size: 20px;
    font-weight: 500;
}

.Statistics-module__coefBox--Yvy0G>h3>span {
    color: #0054E6;
    font-size: 25px;
    font-weight: 600;
}

.Statistics-module__btnBox--f6KaP {
    display: flex;
    justify-content: flex-end;
}

/* В вашем файле Statistics.module.css */
.Statistics-module__legendHidden--UEcRr .Statistics-module__MuiChartsLegend-root--mrVvI {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/statistics/Statistics.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;IACI,aAAa;AACjB","sourcesContent":[".coefBox {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.coefBox>h3 {\r\n    color: #6F879C;\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n}\r\n\r\n.coefBox>h3>span {\r\n    color: #0054E6;\r\n    font-size: 25px;\r\n    font-weight: 600;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n/* В вашем файле Statistics.module.css */\r\n.legendHidden .MuiChartsLegend-root {\r\n    display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coefBox": `Statistics-module__coefBox--Yvy0G`,
	"btnBox": `Statistics-module__btnBox--f6KaP`,
	"legendHidden": `Statistics-module__legendHidden--UEcRr`,
	"MuiChartsLegend-root": `Statistics-module__MuiChartsLegend-root--mrVvI`
};
export default ___CSS_LOADER_EXPORT___;
